export type FormFields =
    'mass' |
    'inlet' |
    'outlet' |
    'v100' |
    'v100_2' |
    'maxDp' |
    'maxDp_2' |
    'kvs' |
    'kvs_2';

export const FormFieldNames: FormFields[] = [
    'mass',
    'inlet',
    'outlet',
    'v100',
    'maxDp',
    'kvs',
    'v100_2',
    'maxDp_2',
    'kvs_2',
];
